<div class="container-xl gx-0 gx-lg-4">
  <div class="row gx-0 gx-lg-3 collection-meta">
    <div
      *ngIf="collection?.products && collection.products.length != 0"
      class="col-12 d-flex flex-column justify-content-between align-items-start"
    >
      <div>
        <h1 class="px-4 px-lg-0 display-1 mb-0">{{ collection.title }}</h1>
      </div>
      <div
        class="px-4 px-lg-0 mt-2 less-content"
        *ngIf="collection?.body_html"
        [innerHTML]="collection.body_html"
      ></div>

      <ng-container *ngIf="_moreContent">
        <div class="px-4 px-lg-0">
          <div
            class="readmore action"
            (click)="_show = !_show"
            *ngIf="!_show && _additionalText"
          >
            Read More
          </div>
          <div
            class="more-content"
            [hidden]="!_show"
            [innerHTML]="_additionalText"
          ></div>
          <div
            class="readless action"
            (click)="_show = !_show"
            *ngIf="_show && _additionalText"
          >
            Read Less
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col text-center">
      <ng-container
        *ngIf="collection?.products && collection.products.length == 0"
      >
        <h1 class="display-1 mt-4 mb-4">No Products Found</h1>
        <p>Please try another collection!</p>
      </ng-container>
    </div>
  </div>
</div>

<div
  class="container-xl gx-x"
  *ngIf="collection && collection.products.length != 0"
>
  <div class="row gx-x">
    <div
      class="filters ps-2 flex-column d-lg-flex col-lg-4"
      [ngClass]="{ active: _toggleFilters }"
    >
      <div class="inner">
        <div
          class="title d-flex flex-row justify-content-between align-items-center align-items-lg-end"
        >
          <h3 class="mb-0">
            Filter <span class="d-none d-lg-inline">& Sort</span>
          </h3>

          <div
            class="clear d-none action d-lg-block"
            *ngIf="active.length > 0"
            (click)="clearAll()"
          >
            Clear All
          </div>
          <svg
            class="d-lg-none"
            (click)="toggleFilters()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.9"
              d="M6.5 6.5L17.5 17.5"
              stroke="black"
              stroke-width="2"
              stroke-linecap="square"
            />
            <path
              opacity="0.9"
              d="M17.5 6.5L6.5 17.5"
              stroke="black"
              stroke-width="2"
              stroke-linecap="square"
            />
          </svg>
        </div>
        <ng-container *ngFor="let facet of facets; let last = last">
          <mercury-filter-accordion
            class="d-flex flex-column"
            [facet]="facet"
          ></mercury-filter-accordion>
          <hr *ngIf="!last" />
        </ng-container>
      </div>
    </div>
    <div
      class="bg d-lg-none"
      (click)="toggleFilters()"
      [ngClass]="{ active: _toggleFilters }"
    ></div>
    <div class="col-12 col-lg-8">
      <div class="grid gx-3">
        <ng-container
          *ngFor="let element of collection?.campaign?.blocks || []"
        >
          <div
            #child
            [attr.id]="element?.id"
            *ngIf="!element?.handle"
            [ngClass]="[element?._classes || '']"
            class="mercury-merchandise-element"
          ></div>
        </ng-container>
        <ng-container
          *ngFor="let element of collection?.products; let index = index"
        >
          <app-collection-item
            [routerLink]="['/products/', element.handle]"
            class="g-col-12 g-col-lg-6 action"
            [product]="element"
            [style.order]="index + 1"
            *ngIf="element.handle"
          ></app-collection-item>
        </ng-container>
      </div>
      <div
        *ngIf="collection.facets.count > pageNo * 20"
        class="d-flex justify-content-center"
      >
        <a
          (click)="loadMore()"
          preventDefault
          [href]="'/collections/' + collection.handle + '?page=' + pageNoNext"
          class="btn btn-primary py-4"
        >
          Load More
        </a>
      </div>
    </div>
  </div>
</div>
<div [appStoryblok]="_editable" *ngFor="let blok of story?.content?.body">
  <ndc-dynamic
    *ngIf="components"
    [ndcDynamicComponent]="components[blok.component]"
    [ndcDynamicInputs]="blok"
  >
  </ndc-dynamic>
</div>
<div
  class="btn btn-lg btn-primary filter-toggle d-lg-none"
  (click)="toggleFilters()"
>
  Filters & Sort
</div>
